import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabTestApi } from '../api/labtest.api';
import { switchMap, map } from 'rxjs/operators';

import { LabTestData, LabTest } from '../../../interfaces/masters/labtest' ;
@Injectable()
export class LabTestService extends LabTestData {

    constructor(private api: LabTestApi) {
      super();
    }
  
  
    list(url: string): Observable<LabTest[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LabTest>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LabTest): Observable<LabTest[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:LabTest): Observable<LabTest> {
      return this.api.update(url,data);
    }

      //for labunitmst excelport
      postData(url: string, data:any[]): Observable<any> {
        return this.api.addData(url,data);
      }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  